import type { LinkProps } from '@tanstack/react-router'

import {
  MINE_PARAM,
  PROJECT_PERSON_NONE,
  PROJECT_POSTS,
} from '@brickup/shared/constants'
import { STAFF_DASHBOARD } from '@brickup/shared/locales/de/staff-dashboard'
import { type StatusFilter } from '@/components/Internal/Projects/project-list-filters'

/** Where the dashboards point: the screens that already show each thing. */
export const projectLink = (id: number): LinkProps => ({
  to: '/internal/projects/$id',
  params: { id: String(id) },
})

/**
 * The project list narrowed the way the figure that links to it was counted:
 * to one status, and to the reader's own projects where the figure only
 * counted those.
 */
export const projectsLink = ({
  status,
  mine,
  advisor,
}: {
  /** Omitted, the list opens on its own default, which is the active ones. */
  status?: StatusFilter
  /** Set where the figure counted the reader's own projects. No id travels:
   *  the list resolves it against whoever opens the link. */
  mine?: boolean
  /** A `User.id` for the figure that counted one advisor's projects, or null
   *  for the row that counted the projects naming no advisor — which is the
   *  post the advisor-load list is grouped by. */
  advisor?: number | null
}): LinkProps => ({
  to: '/internal/projects',
  search: {
    ...(status && { status }),
    ...(mine && { [MINE_PARAM]: true }),
    ...(advisor !== undefined && {
      [PROJECT_POSTS.advisor.param]:
        advisor == null ? PROJECT_PERSON_NONE : String(advisor),
    }),
  },
})

/** A matched property, opened with the mandate's customer beside it — where
 *  the notification about the same reaction leads. */
export const matchLink = (
  propertyId: number,
  mandateId: string,
): LinkProps => ({
  to: '/internal/properties',
  search: { selected: propertyId, customer: mandateId },
})

/** Under a list that was cut to its first entries: how many it left out. */
export const moreFooter = (total: number, shown: number): string | undefined =>
  total > shown ? STAFF_DASHBOARD.more(total - shown) : undefined
